var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3874_107451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3874_107451)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24309 2.19148C9.63361 1.80096 10.2668 1.80096 10.6573 2.19148L15.7076 7.24177C16.0981 7.6323 16.0981 8.26546 15.7076 8.65599L10.6573 13.7063C10.2668 14.0968 9.63361 14.0968 9.24309 13.7063C8.85256 13.3158 8.85256 12.6826 9.24309 12.2921L13.5863 7.94888L9.24309 3.6057C8.85256 3.21517 8.85256 2.58201 9.24309 2.19148Z",
    fill: "#EB254C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 8.55228 15.5523 9 15 9L1 9C0.447715 9 3.91404e-08 8.55228 8.74224e-08 8C1.35705e-07 7.44771 0.447715 7 1 7L15 7C15.5523 7 16 7.44772 16 8Z",
    fill: "#EB254C"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzM4NzRfMTA3NDUxIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiNDNEM0QzQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzM4NzRfMTA3NDUxKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS4yNDMwOSAyLjE5MTQ4QzkuNjMzNjEgMS44MDA5NiAxMC4yNjY4IDEuODAwOTYgMTAuNjU3MyAyLjE5MTQ4TDE1LjcwNzYgNy4yNDE3N0MxNi4wOTgxIDcuNjMyMyAxNi4wOTgxIDguMjY1NDYgMTUuNzA3NiA4LjY1NTk5TDEwLjY1NzMgMTMuNzA2M0MxMC4yNjY4IDE0LjA5NjggOS42MzM2MSAxNC4wOTY4IDkuMjQzMDkgMTMuNzA2M0M4Ljg1MjU2IDEzLjMxNTggOC44NTI1NiAxMi42ODI2IDkuMjQzMDkgMTIuMjkyMUwxMy41ODYzIDcuOTQ4ODhMOS4yNDMwOSAzLjYwNTdDOC44NTI1NiAzLjIxNTE3IDguODUyNTYgMi41ODIwMSA5LjI0MzA5IDIuMTkxNDhaIiBmaWxsPSIjRUIyNTRDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYgOEMxNiA4LjU1MjI4IDE1LjU1MjMgOSAxNSA5TDEgOUMwLjQ0NzcxNSA5IDMuOTE0MDRlLTA4IDguNTUyMjggOC43NDIyNGUtMDggOEMxLjM1NzA1ZS0wNyA3LjQ0NzcxIDAuNDQ3NzE1IDcgMSA3TDE1IDdDMTUuNTUyMyA3IDE2IDcuNDQ3NzIgMTYgOFoiIGZpbGw9IiNFQjI1NEMiLz4KPC9nPgo8L3N2Zz4K";
export { SvgRedArrow as ReactComponent };